import { render } from "./ExtAuth.vue?vue&type=template&id=6278eb25&scoped=true"
import script from "./ExtAuth.vue?vue&type=script&lang=js"
export * from "./ExtAuth.vue?vue&type=script&lang=js"

import "./ExtAuth.vue?vue&type=style&index=0&id=6278eb25&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6278eb25"]])

export default __exports__